import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/layouts/Default'
import Home from '../views/Home'
import Add from '../views/Add'
import Data from '../views/Data'
import Login from '../views/Login'
import Logout from '../views/Logout'
import { firebase } from '../firebase-config.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [    
    {
      path: '/login',
      title: 'login',
      component: Login
    }, 
    {
      path: '/logout',
      title: 'logout',
      component: Logout,
      meta: {
        requiresAuth: true
      }
    }, 
    {
      path: '/data',
      title: 'Data',
      component: Data,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/login',
          title: 'login',
          component: Login
        },
        {
          path: '/add',
          title: 'Add',
          component: Add,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/login',
          title: 'Login',
          component: Data,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update/:id',
          title: 'Update',
          component: Add,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/',
          title: 'Start',
          component: Home,
          meta: {
            requiresAuth: true
          }
        }
      ]   
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) router.push({ path: 'Login' }) 
  else if (to.path === '/data') next()
  else if (!requiresAuth && currentUser) next('/')
  else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js